import React from 'react';
import colors from '../../utils/colors';
import typography from '../../utils/typography';

const Tooltip = ({ 
  text, 
  isVisible, 
  position = 'top', 
  offset = 4,
  className = ""
}) => {
  if (!isVisible || !text) return null;

  const getPositionStyles = () => {
    const safeOffset = typeof offset === 'number' ? offset : 4;
    switch (position) {
      case 'top':
        return {
          left: '50%',
          bottom: `calc(100% + ${safeOffset}px)`,
          transform: 'translateX(-50%)'
        };
      case 'bottom':
        return {
          left: '50%',
          top: `calc(100% + ${safeOffset}px)`,
          transform: 'translateX(-50%)'
        };
      case 'left':
        return {
          right: `calc(100% + ${safeOffset}px)`,
          top: '50%',
          transform: 'translateY(-50%)'
        };
      case 'right':
        return {
          left: `calc(100% + ${safeOffset}px)`,
          top: '50%',
          transform: 'translateY(-50%)'
        };
      default:
        return {
          left: '50%',
          bottom: `calc(100% + ${safeOffset}px)`,
          transform: 'translateX(-50%)'
        };
    }
  };

  return (
    <div
      className={`absolute flex justify-center items-center z-30 text-center whitespace-nowrap select-none pointer-events-none ${className}`}
      style={{
        ...typography.xsmall.regular,
        padding: '8px 12px',
        borderRadius: '8px',
        backdropFilter: 'blur(25px)', 
        WebkitBackdropFilter: 'blur(25px)', 
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        color: colors.text.primary || '#FAF7F5',
        ...getPositionStyles()
      }}
    >
      {text}
    </div>
  );
};

export default Tooltip;